import React from 'react'
import Item from './Item'
import {Accordion} from 'react-bootstrap'
import {Newsletters, professionalSpace, Year2024, Year2025, Year2026} from '../items'

const ProfessionalSpaceAccordion = () => {
    return (
        <div>
            <Accordion style={{direction: "rtl"}}>
                <Item items={Year2026.items} eventKey="0"/>
                <Item items={Year2025.items} eventKey="1"/>
                <Item items={Year2024.items} eventKey="2"/>
                <Item items={Newsletters.items} eventKey="3"/>
                <Item items={professionalSpace.items} eventKey="4"/>
            </Accordion>
        </div>
    )
}

export default ProfessionalSpaceAccordion